export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./lk-file.vue?vue&type=template&id=0a7c0e95&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/lk/lk-file/lk-file.vue?vue&type=template&id=0a7c0e95&
// module id = 1395
// module chunks = 0